/* eslint-disable no-unused-vars */
import axios from 'axios';

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  data() {
    return {
      user: {
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        checkedRules: false,
        checkedPers: false,
        allow_push: false,
        role: 'seller',
        dealer: null,
        fact_name_dealer: '',
        dealer_addresses: [],
        current_address: '',
        city_id: null,
        channel_id: null,
        comment: '',
        distributors_ids: [],
      },
      addressSuggestions: [],
      selectedAddressData: null,
      pageRules: {
        title: 'Тайтл соглашения',
        content: 'Подтверждение согласия на обработку ПД',
      },
      pagePers: {
        title: 'Тайтл соглашения',
        content: 'Согласие с правилами мотивационной программы',
      },
      dialogRules: false,
      dialogPers: false,
      code: '',
      sentCode: false,
      token: '',
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        password: (v) => {
          if (!v) return 'Укажите пароль';
          if (!/[A-Z]/.test(v)) return 'Пароль должен содержать хотя бы одну заглавную букву';
          if (!/[0-9]/.test(v)) return 'Пароль должен содержать хотя бы одну цифру';
          if (!/[!@#$%^&*()_+\-=[\]{}|;':",./<>?`~\\]/.test(v)) return 'Пароль должен содержать хотя бы один спец. символ';
          return true;
        },
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
        notEmpty: v => (!!v && v.length > 0) || 'Поле должно быть заполнено',
        dealerAddresses: v => (Array.isArray(this.user.dealer_addresses) && this.user.dealer_addresses.length > 0) || 'Добавьте хотя бы один фактический адрес',
      },
      valid: false,
      profile: {},
      search: '',
      searchCity: '',
      searchInn: '',
      suggestions: [],
      isLoadingSuggest: false,
      isLoadingCompanies: false,
      cities: [],
      dealers: [],
      innAvailable: true,
      innWarningMessage: '',
    };
  },
  watch: {
    searchCity(city) {
      const app = this;
      if (city && city.length) {
        app.$store.getters.ax.post('profiles/api/location/cities', { term: city, limit: 30 })
          .then((result) => {
            app.cities = result.data.cities;
          });
      }
    },
    searchInn(inn) {
      const app = this;
      app.innAvailable = true;
      app.innWarningMessage = '';
      if (!inn || (inn.length !== 10 && inn.length !== 12)) {
        app.dealers = [];
        return;
      }
      const trimmedInn = String(inn).trim();
      if (trimmedInn.length !== 10 && trimmedInn.length !== 12) return;
      app.$store.getters.ax.post('profiles/api/dealers/find-by-inn', { inn: trimmedInn })
        .then((result) => {
          app.dealers = result.data.data || [];
          return app.$store.getters.ax.post('profiles/api/dealers/check-inn', { inn: trimmedInn });
        })
        .then((result) => {
          if (result && result.data && result.data.available === false) {
            this.innAvailable = false;
            this.innWarningMessage = result.data.message || 'Под данным ИНН уже пройдена регистрация.';
          }
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.dealers = [];
        });
    },
    'user.dealer': function (dealer) {
      if (!dealer || !dealer.inn) {
        this.innAvailable = true;
        this.innWarningMessage = '';
        return;
      }
      const app = this;
      app.$store.getters.ax.post('profiles/api/dealers/check-inn', { inn: String(dealer.inn).trim() })
        .then((result) => {
          if (result && result.data && result.data.available === false) {
            app.innAvailable = false;
            app.innWarningMessage = result.data.message || 'Под данным ИНН уже пройдена регистрация.';
          } else {
            app.innAvailable = true;
            app.innWarningMessage = '';
          }
        })
        .catch(() => {
          app.innAvailable = true;
          app.innWarningMessage = '';
        });
    },
  },
  computed: {
    requireRules() {
      return this.$store.state.settings.register_rules === true;
    },
    requirePers() {
      return this.$store.state.settings.register_pers === true;
    },
    type() {
      if (this.$store.state.settings.registration === 'unregistered_by_phone') {
        return 'sms_noprofile_or_unregistered';
      }
      if (this.$store.state.settings.registration === 'existing_by_phone') {
        return 'sms_profile_unregistered';
      }
      if (this.$store.state.settings.registration === 'free_by_phone') {
        return 'sms_noprofile';
      }
      if (this.settings && this.settings.registration === 'free_by_email') {
        return 'email_noprofile';
      }
      return null;
    },
    isSmsNoProfile() { return this.type === 'sms_noprofile'; },
    isEmailNoProfile() { return this.type === 'email_noprofile'; },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    phoneMask() {
      return this.user.phone[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
    distributorsList() {
      return this.$store.state.profiles.distributorsList;
    },
    channelsList() {
      return this.$store.state.profiles.channelsList;
    },
  },
  methods: {
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadRegInfo() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
          const { profile } = response.data;
          if (profile) {
            app.user.first_name = profile.first_name;
            app.user.last_name = profile.last_name;
            app.user.middle_name = profile.middle_name;
            app.user.email = profile.email;
          }
        });
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        const el = document.getElementById(id);
        if (el) el.focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = {
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        comment: '',
        dealer: null,
        fact_name_dealer: '',
        dealer_addresses: [],
        current_address: '',
        role: 'seller',
        city_id: null,
        channel_id: null,
        checkedRules: false,
        checkedPers: false,
        allow_push: false,
        distributors_ids: [],
      };
      this.addressSuggestions = [];
      this.selectedAddressData = null;
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;
      this.searchCity = '';
      this.cities = [];
      this.dealers = [];
      this.innAvailable = true;
      this.innWarningMessage = '';

      this.$nextTick(() => this.Focus(this.isEmailNoProfile ? 'regEmail' : 'regPhone'));
    },
    /** Отправка проверочного СМС кода */
    SendCode() {
      const app = this;
      let url = 'api/token/get-email';
      const data = { type: app.type };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'api/token/get-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then(() => {
          app.sentCode = true;
          app.Focus('regCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
        });
    },
    /** Проверка кода полученного в СМС */
    CheckCode() {
      const app = this;
      let url = 'api/token/check-email';
      const data = { type: app.type, code: app.code };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'api/token/check-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('password');
          app.LoadRegInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      const formData = { ...app.user };
      formData.fact_name = formData.fact_name_dealer;
      delete formData.fact_name_dealer;
      formData.token = app.token;
      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }

      app.$store.getters.axl.post('profiles/api/register', formData)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async AutocompleteSearch(queryString) {
      queryString = this.search;
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      this.isLoadingSuggest = true;
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      await axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
        })
        .finally(() => {
          this.isLoadingSuggest = false;
        });
    },
    AutocompleteSelect(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.profile.address = sug.data;
          const addressEl = document.getElementById('address');
          if (addressEl) addressEl.focus();
        }
      });
    },
    AddressSuggest(queryString, cb) {
      if (!queryString || queryString.length < 3) {
        cb([]);
        return;
      }
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };
      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          this.addressSuggestions = res.data.suggestions || [];
          cb(this.addressSuggestions);
        })
        .catch(() => cb([]));
    },
    AddressSelect(item) {
      this.selectedAddressData = this.addressSuggestions
        .find(s => s.value === item.value)?.data || null;
      this.user.current_address = item.value;
    },
    AddDealerAddress() {
      const addr = (this.user.current_address || '').trim();
      if (!addr) return;
      if (!this.user.dealer_addresses.includes(addr)) {
        this.user.dealer_addresses = [...this.user.dealer_addresses, addr];
      }
      this.user.current_address = '';
      this.selectedAddressData = null;
    },
    RemoveDealerAddress(idx) {
      this.user.dealer_addresses = this.user.dealer_addresses.filter((_, i) => i !== idx);
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.$store.dispatch('profiles/GetDistributorsList');
    this.$store.dispatch('profiles/GetChannelsList');
    this.$nextTick(() => this.Focus(this.isEmailNoProfile ? 'regEmail' : 'regPhone'));
  },
};
